/**
 * Best-effort city from the last line of a typical Indian address ("City - 380054").
 */
export function inferHeadOfficeCityFromAddress(addressBlock) {
  if (!addressBlock) return '';
  const lines = String(addressBlock)
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean);
  if (!lines.length) return '';
  const last = lines[lines.length - 1];
  const pin = last.match(/^(.+?)\s*-\s*(\d{6})\s*$/);
  if (pin) return pin[1].trim();
  const pin2 = last.match(/,\s*([^,]+?)\s*-\s*\d{6}\s*$/);
  if (pin2) return pin2[1].trim();
  return '';
}
